import { atom } from 'jotai';

export const internalNotesCountAtom = atom<number | null>(null);
